






































import Vue from "vue";
import { name as squareRoute } from './Square/Square.vue';
import { name as linesRoute} from './Lines/Lines.vue';
import { name as squigglesRoute} from './Squiggles/Squiggles.vue';
import squaresPng from "./screenshots/squares.png";
import linesPng from "./screenshots/lines.png";
import squigglePng from "./screenshots/squiggle.png";

interface ArtPiece {
  name: string;
  thumbnail: string;
  route: object;
  blurb?: string;
}

interface Data {
  artPieces: ArtPiece[];
}

export default Vue.extend({
  data(): Data {
    return {
      artPieces: [
        {
          name: squareRoute,
          blurb: "Use dots to draw squares",
          thumbnail: squaresPng,
          route: {
            name: squareRoute, query: { random: true } 
          }
        },
        {
          name: linesRoute,
          blurb: "Toss a coin draw a diagonal",
          thumbnail: linesPng,
          route: { name: linesRoute, query: { random: true } }
        },
        {
          name: squigglesRoute,
          blurb: "Toss a coin draw a squiggle",
          thumbnail: squigglePng,
          route: { name: squigglesRoute, query: { random: true } }
        },
      ],
    };
  },
});
